namespace $ { $mol_style_attach( "brbr/brbr/logo/logo.view.css",
 "[brbr_brbr_logo] {\n\tanimation: rotate 4s infinite;\n}\n\n@keyframes rotate {\n\t0% {\n\t\ttransform: rotate(0deg)\n\t}\n\n\t100% {\n\t\ttransform: rotate(360deg)\n\t}\n}\n"
) }